import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Heart } from "lucide-react";
import { fmtEUR } from "./don/euros";
import { texteJour } from "../../lib/etatCampagne";

const STATUTS_CLOS = ["completed", "archived"];

/**
 * Campagne TERMINÉE : remplace la jauge et le formulaire (aucun don
 * possible, le serveur le refuse). On remercie plutôt que d'afficher une
 * barre figée qui se lirait comme un échec :
 *   « Merci à tous · 12 400 € réunis »
 * Le montant est le PROMIS (le chiffre que la page montrait aux donateurs),
 * arrondi vers le bas comme pendant la campagne. Paniers : le nombre de
 * paniers (« 38 paniers »), l'unité que la page a montrée pendant toute la
 * campagne. Réservation de places : le nombre de places confirmées (le promis
 * y compterait aussi la liste d'attente). Rien de promis : « Merci à tous ».
 */
export default function MerciCampagneTerminee({
  campaign, etat, themeColor, titleFont, organisationNom,
}) {
  const stats = campaign.stats || {};
  const places = campaign.type === "seats_request";
  const paniers = campaign.type === "unit_qty" && Number(stats.units_committed) > 0;
  let bilan = null;
  if (places) {
    const n = (stats.seats_taken_adults || 0) + (stats.seats_taken_children || 0);
    if (n > 0) bilan = `${n} place${n > 1 ? "s" : ""} réservée${n > 1 ? "s" : ""}`;
  } else if (paniers) {
    const n = Number(stats.units_committed);
    const unite = campaign.unit_label || "unité";
    bilan = `${n} ${unite}${n > 1 && !unite.endsWith("s") ? "s" : ""}`;
  } else if (Math.floor(Number(stats.committed) || 0) > 0) {
    bilan = `${fmtEUR(Math.floor(Number(stats.committed)))} réunis`;
  }
  const donateurs = places ? 0 : stats.donors_count || 0;
  // Même message que le serveur : « s'est terminée le … » seulement quand
  // c'est la DATE qui a fermé la campagne (pas un arrêt manuel du rav).
  const jour = !STATUTS_CLOS.includes(campaign.status) && etat?.fin_le
    ? texteJour(etat.fin_le) : null;
  const suite = places ? "les réservations sont closes." : "elle n'accepte plus de dons.";

  return (
    <section className="bg-white rounded-3xl p-6 sm:p-8 border border-stone-200 text-center"
      data-testid="merci-campagne-terminee">
      <div className="h-14 w-14 rounded-full bg-emerald-50 flex items-center justify-center mx-auto mb-4">
        <Heart className="h-6 w-6 text-emerald-600" />
      </div>
      <h2 className="text-3xl font-light leading-tight" style={{ fontFamily: titleFont, color: themeColor }}>
        {bilan ? `Merci à tous · ${bilan}` : "Merci à tous"}
      </h2>
      {donateurs > 0 && (
        <p className="text-sm text-stone-500 mt-2">
          grâce à {donateurs} donateur{donateurs > 1 ? "s" : ""}
        </p>
      )}
      <p className="text-sm text-stone-600 mt-4 leading-relaxed">
        {jour
          ? `Cette campagne s'est terminée le ${jour} : ${suite}`
          : `Cette campagne est terminée : ${suite}`}
      </p>
      {organisationNom && campaign.organization_id && (
        <Link to={`/organisations/${campaign.organization_id}`}
          className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-stone-700 underline underline-offset-4 decoration-stone-300 hover:text-stone-900">
          Voir la page de {organisationNom}
          <ArrowRight className="h-4 w-4" />
        </Link>
      )}
    </section>
  );
}
